import '../../../app.css';
import '../../../title/title.css';
import '../../game.css';

const React = require('react');
const styles = require('../../game.style').default;
const assets = require('../../../../assets').default;
const ModalWindow = require('../../../../core/modal').default;
const { getStartStageScenario, stageScenario } = require('../../../../core/stageData').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

export default class stageScenarioComponent extends React.Component {
    renderTutorial() {
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>操作方法について:</div>
                            <div>ポリンボックスを引っ張ると配置できます</div>
                            <div>プレイヤーを引っ張るとスキル発動！</div>
                        </div>
                        <div className="stage-tips-image-flex">
                            <img src={assets.TipsImage} className="tips-image" />
                        </div>
                    </div>
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>ルールについて:</div>
                            <div>同じ色のポリンをつなげてスキルを当てれば連鎖していきます</div>
                            <div>モンスターに当てることで大ダメージ！</div>
                            <div>宝箱以外のモンスターをすべて倒せばステージクリア！</div>
                        </div>
                        <div className="stage-tips-image-flex">
                            <img src={assets.StageTipsImage} className="tips-image" />
                        </div>
                    </div>

                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleButtonClick()
                        }}>OK</div>
                    </div>
                </div>
            </div>
        )
    }

    renderOpening() {
        const { playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>魔女ジラント:</div>
                            <div>ふふふ、我が城へようこそ、歓迎するぞ。豪華な晩餐を用意してある。お前たちをその席に招待しよう</div>
                            <div>ふふっ、遅れるでないぞ</div>
                        </div>
                        <div className="tips-image-flex">
                            <img src={assets.ModalZilant} className="tips-image" style={{ opacity: 0.5 }} />
                        </div>
                    </div>
                    <div className="tips-message">
                        <div className="tips-image-flex">
                            <img src={assets.ModalMea02} className="tips-image" />
                        </div>
                        <div className="tips-text">
                            <div>王女メア：</div>
                            <div>我が城などと……貴女がこの城を乗っ取ったのは知っています！　我々は貴女を討つために、ここに来たのです！</div>
                            <div>{playerName}様！　魔女を追いかけましょう！</div>
                        </div>
                    </div>

                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleButtonClick()
                        }}>OK</div>
                    </div>
                </div>
            </div>
        )
    }

    renderWitchHint() {
        const { playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>魔女ジラント:</div>
                            <div>ふふっ……約束の時間には遅刻せずに済んだようだな。では……メインディッシュにその極上の魂をいただくとしよう！</div>
                            <div>我が不死の秘術……とくと見るが良い</div>
                        </div>
                        <div className="tips-image-flex">
                            <img src={assets.ModalZilant} className="tips-image" style={{ opacity: 0.5 }} />
                        </div>
                    </div>
                    <div className="tips-message">
                        <div className="tips-image-flex">
                            <img src={assets.ModalMea02} className="tips-image" />
                        </div>
                        <div className="tips-text">
                            <div>王女メア：</div>
                            <div>魔女の体から生気が感じられません。本体を探さねばならないようです</div>
                            <div>{playerName}様！ いずれか本体の魔獣を倒し、魔女を討伐しましょう！</div>
                        </div>
                    </div>

                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleButtonClick()
                        }}>OK</div>
                    </div>
                </div>
            </div>
        )
    }

    renderBeastHint() {
        const { playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-image-flex">
                            <img src={assets.ModalMea02} className="tips-image" />
                        </div>
                        <div className="tips-text">
                            <div>王女メア：</div>
                            <div>{playerName}様！ あれは……魔女の召喚した魔獣です！　防御力が高いので気を付けてください</div>
                            <div>あのモンスターには特定の攻撃以外はきかないようです！</div>
                        </div>
                    </div>

                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleButtonClick()
                        }}>OK</div>
                    </div>
                </div>
            </div>
        )
    }

    renderError() {
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                            this.props.handleButtonClick()
                        }}>OK</div>
                    </div>
                </div>
            </div>
        )
    }

    renderContents() {
        const { gameState: { arrivalStage } } = this.props;
        const scenario = getStartStageScenario(arrivalStage);
        switch (scenario) {
            case stageScenario.SCENARIO_TUTORIAL:
                return this.renderTutorial();
            case stageScenario.SCENARIO_OPENING:
                return this.renderOpening();
            case stageScenario.SCENARIO_BEAST:
                return this.renderBeastHint();
            case stageScenario.SCENARIO_WITCH:
                return this.renderWitchHint();
            default:
                return this.renderError();;
        }
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}